let notificationContext = null;
export const setNotificationContext = (context) => {
  notificationContext = context;
};

const showNotification = (title, message, type = 'info', options = {}) => {
  if (!notificationContext) {
    console.warn('Notification context not available');
    return;
  }
  switch (type) {
    case 'success':
      notificationContext.showSuccess(message, title, options);
      break;
    case 'error':
    case 'danger':
      notificationContext.showError(message, title, options);
      break;
    case 'warning':
      notificationContext.showWarning(message, title, options);
      break;
    case 'info':
    default:
      notificationContext.showInfo(message, title, options);
      break;
  }
};

export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

export const showSuccess = (title, message, options = {}) => {
  showNotification(title, message, NOTIFICATION_TYPES.SUCCESS, options);
};
export const showError = (title, message, options = {}) => {
  showNotification(title, message, NOTIFICATION_TYPES.ERROR, options);
};
export const showWarning = (title, message, options = {}) => {
  showNotification(title, message, NOTIFICATION_TYPES.WARNING, options);
};
export const showInfo = (title, message, options = {}) => {
  showNotification(title, message, NOTIFICATION_TYPES.INFO, options);
};
export const showCustom = (title, message, type, customOptions = {}) => {
  showNotification(title, message, type, customOptions);
}

export const clearNotifications = () => {
  if (!notificationContext) {
    console.warn('Notification context not available');
    return;
  }
  notificationContext.clearNotifications();
};

export default {
  showInfo,
  showError,
  showCustom,
  showSuccess,
  showWarning,
  clearNotifications,
  NOTIFICATION_TYPES,
};
